import { createFileRoute } from '@tanstack/react-router'
import { AdminSegmentsPage } from '@/components/admin/marketing/AdminSegmentsPage'

export const Route = createFileRoute('/admin/marketing/segments')({
  component: () => <AdminSegmentsPage />,
})
